import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
  import './ContactPage.css';
const ContactPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialObject = params.get('object') || '';
  const [formData, setFormData] = useState({ name: '', email: '', telephone: '', message: '', object: initialObject });
  const [statusMessage, setStatusMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatusMessage('');

    try {
      // Calling the backend API endpoint as requested
      // In development, send to localhost:3000 for the dev server
      const apiUrl = '/api/contact';
      //  const apiUrl = 'http://localhost:3000/contact';
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        // ensure strict-origin-when-cross-origin referrer policy for this request
        referrerPolicy: 'strict-origin-when-cross-origin',
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatusMessage('Votre message a été envoyé avec succès ! Nous vous répondrons rapidement.');
        setFormData({ name: '', email: '', telephone: '', message: '', object: '' }); // Clear form
      } else {
        // Handle server-side errors
        const errorData = await response.json();
        throw new Error(errorData.message || 'Une erreur est survenue lors de l\'envoi du formulaire.');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setStatusMessage(`Erreur : ${error instanceof Error ? error.message : 'Veuillez réessayer.'}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    
    <div className="contact-page-container">
      
        <>
          <h1>Contactez-nous</h1>
          <p>Nous serons ravis de discuter de votre projet avec vous. Remplissez simplement le formulaire ci-dessous.</p>
          <div className="contact-grid">
          <div className="contact-form-card">
            <form onSubmit={handleSubmit}>
              {/* Name Field */}
              <div className="form-group">
                <label htmlFor="name">Nom</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  placeholder="Votre nom complet"
                />
              </div>

              {/* Email Field */}
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  placeholder="votre@email.com"
                />
              </div>
               <div className="form-group">
                <label htmlFor="telephone">Téléphone</label>
                <input
                  type="tel"
                  id="telephone"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  placeholder="votre numéro de téléphone"
                />
              </div>
              <div className="form-group">
                <label htmlFor="object">Object</label>
                <input
                  type="text"
                  id="object"
                  name="object"
                  value={formData.object}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  placeholder="object de votre demande"
                />
              </div>
              {/* Message Field */}
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                    required
                    disabled={isSubmitting}
                    onChange={handleChange}
                    placeholder="Décrivez votre demande ici..."
                ></textarea>
              </div>

              {/* Submit Button */}
              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Envoi en cours...' : 'Envoyer le message'}
              </button>
            </form>

            {/* Status Message Display */}
            {statusMessage && (
              <p className={`status-message ${statusMessage.startsWith('Erreur') ? 'error' : 'success'}`}>
                {statusMessage}
              </p>
            )}
          </div>

          {/* Map Placeholder - You can integrate a real map component here */}
          <aside className="map-container" >
            <h3>Notre adresse</h3>
        <p>6 le jariel<br />77510 Sablonnières</p>
        {/* <p><a href="https://www.google.com/maps/search/?api=1&query=6+le+jariel,+77510+Sablonni%C3%A8res" target="_blank" rel="noopener">Ouvrir dans Google Maps</a></p> */}
        <h3>Email</h3>
        <p><a href="mailto:contact@sabtosdupetitmorin.fr">contact@sabtosdupetitmorin.fr</a></p>
        <div className="contact-map">
          <div className="map-wrap">
            <iframe
                          title="map"
                          src="https://maps.google.com/maps?q=6%20le%20Jariel,%2077510%20Sablonnières&t=&z=15&ie=UTF8&iwloc=&output=embed"
                          style={{ border: 0, width: '100%', height: '100%' }}
                          loading="lazy"
                        />
          </div>
        </div>
          </aside>
          </div>
        </>
    </div>
  );
};

export default ContactPage;